import ChannelListBottomContainer from '@components/atoms/container/channelListBottomContainer';
import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListProgressBar from '@components/elements/channelList/channelListProgressBar';
import ChannelListTip from '@components/elements/channelList/channelListTip';
import ChannelListUpgradablePlan from '@components/elements/channelList/channlListUgradablePlan';
import { useContext } from 'react';

export default function ChannelListBottom() {
  const { plan } = useContext(ChannelListContext);

  return (
    <ChannelListBottomContainer id={'channelListBottomContainer'}>
      {plan ? (
        <ChannelListUpgradablePlan plan={plan} />
      ) : (
        <>
          <ChannelListProgressBar />
          <ChannelListTip />
        </>
      )}
    </ChannelListBottomContainer>
  );
}
